export default __webpack_public_path__ + "static/media/polite.33da6e31.wav";